import Text from '@components/atoms/Text/Text'
import PropTypesUtils from '@utils/propTypes'
import c from 'classnames'
import PropTypes from 'prop-types'

import styles from './LightBox.module.scss'

const LightBox = ({ title, body, buttons, onClose }) => {
  const onBackRefClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div className={styles.base}>
      <div className={styles.backPane} onClick={onBackRefClick} />

      <div className={c(styles.box, 'u-6/14@md')}>
        <div className={styles.close} onClick={onClose}>
          <i className="c-grey icon icon-close" />
        </div>

        <div className={c(styles.warning, 'b-orangeLighter')}>
          <i className="icon icon-warning c-orange"></i>
        </div>

        <div className={styles.title}>
          <Text type="h3">{title}</Text>
        </div>
        <div className={styles.body}>
          <Text type="text-m">{body}</Text>
        </div>
        <div className={styles.buttons}>{buttons}</div>
      </div>
    </div>
  )
}

LightBox.defaultProps = {}
LightBox.propTypes = {
  title: PropTypesUtils.children.isRequired,
  body: PropTypesUtils.children.isRequired,
  onClose: PropTypes.func.isRequired,
  buttons: PropTypesUtils.children,
}

export default LightBox
